import Vue from 'vue'
import Router from 'vue-router'

//Pages
import Home from '../pages/Home/Home/Router'
import MinhaConta from '../pages/Inicio/MinhaConta/Router'
import Logs from '../pages/Logs/Logs/Router'

import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Router'
import Usuarios from '../pages/Admin/Usuarios/Router'
import ArtisticoLiterario from '../pages/Links/ArtisticoLiterario/Router'
import Concursos from '../pages/Servicos/Concursos/Router'
import Concursos2023 from '../pages/Servicos/Concursos2023/Router'
import ClassificacaoSemed from '../pages/Servicos/ClassificacaoSemed/Router'
import LegislacoesMunicipais from '../pages/Servicos/LegislacoesMunicipais/Router'
import ControleInterno from '../pages/Servicos/ControleInterno/Router'
import Fornecedores from '../pages/Servicos/Fornecedores/Router'
import AuxilioBrasil from '../pages/Servicos/AuxilioBrasil/Router'
import Licitacoes from '../pages/Servicos/Licitacoes/Router'
import LicitacoesComunicados from '../pages/Servicos/Licitacoes-Comunicados/Router'
import LeiAldirBlanc from '../pages/Links/LeiAldirBlanc/Router'
import Pnab from '../pages/Links/Pnab/Router'
import LeiPauloGustavo from '../pages/Links/LeiPauloGustavo/Router'
import PPA from '../pages/Links/PPA/Router'
import Convenios from '../pages/Servicos/Convenios/Router'
import Legislacao from '../pages/Servicos/Legislacao/Router'
import doem from '../pages/Servicos/doem/Router'
import PregaoOnline from '../pages/Servicos/PregaoOnline/Router'
import PlanejamentoSaude from '../pages/Links/PlanejamentoSaude/Router'
import ProfessoresTemporarios from '../pages/Servicos/ProfessoresTemporarios/Router'
import Servicos from '../pages/Servicos/Servicos/Router'
import Vacinados from '../pages/Links/Vacinados/Router'
import PME from '../pages/Links/PME/Router'
import Banners from '../pages/Site/Banners/Router'
import Destaques from '../pages/Site/Destaques/Router'
import Galerias from '../pages/Site/Galerias/Router'
import Noticias from '../pages/Site/Noticias/Router'
import CasaTrabalhador from '../pages/Site/CasaTrabalhador/Router'
import Secretarias from '../pages/Site/Secretarias/Router'
import Prefeitos from '../pages/Site/Prefeitos/Router'
import Paginas from '../pages/Links/Paginas/Router'
import Videos from '../pages/Site/Videos/Router'

import Redirect from '../pages/redirect/Index/Router'
import Acessar from '../pages/Login/Acessar/Router'
import Erro from '../pages/Erro/404/Router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [
		...Redirect,
		{
			path: '/',
			component: () => import('@/layouts/Default'),
			children: [
				...Home,
				...MinhaConta,
				...Logs,
				...GrupoDeAcesso,
				...Usuarios,
				...Banners,
				...Destaques,
				...Galerias,
				...Noticias,
				...CasaTrabalhador,
				...Secretarias,
				...Paginas,
				...Videos,
				...ArtisticoLiterario,
				...PlanejamentoSaude,
				...ProfessoresTemporarios,
				...Servicos,
				...Vacinados,
				...Fornecedores,
				...doem,
				...Concursos,
				...Legislacao,
				...LeiAldirBlanc,
				...Pnab,
				...PPA,
				...PME,
				...AuxilioBrasil,
				...Licitacoes,
				...LicitacoesComunicados,
				...Convenios,
				...PregaoOnline,
				...Concursos2023,
				...ClassificacaoSemed,
				...LegislacoesMunicipais,
				...ControleInterno,
				...LeiPauloGustavo,
				...Prefeitos,
			]
		},
		...Acessar,
		...Erro,
	]
})